/* global Sys, Core */
Sys.ns("Core");

/**
 * The Local Storage Manager is in charge of reading and writing to/from local storage.
 *
 * @class Core.LocalStorageManager
 * @extends Core.Module
 * @uses Core.LocalStorageManagerController
 * @uses Core.LocalStorageManagerModel
 */
Core.LocalStorageManager = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.LocalStorageManager.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.LocalStorageManagerModel,
            controller: Core.LocalStorageManagerController
        };
    }
};

Core.LocalStorageManager = Sys.extend(Core.Module, Core.LocalStorageManager, "Core.LocalStorageManager");
